import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly defaultStorage = 'local';

  setData(
    key: string,
    data: any,
    storageType: 'local' | 'session' = this.defaultStorage,
  ): void {
    try {
      const storage = this.getStorageByType(storageType);
      const serializedData = JSON.stringify(data);
      storage.setItem(key, serializedData);
    } catch (error) {}
  }

  getData<T>(
    key: string,
    storageType: 'local' | 'session' = this.defaultStorage,
  ): T | null {
    try {
      const storage = this.getStorageByType(storageType);
      const data = storage.getItem(key);

      if (!data) {
        return null;
      }

      return JSON.parse(data) as T;
    } catch (error) {
      return null;
    }
  }

  flush(
    key: string,
    storageType: 'local' | 'session' = this.defaultStorage,
  ): void {
    try {
      const storage = this.getStorageByType(storageType);
      storage.removeItem(key);
    } catch (error) {}
  }

  private getStorageByType(
    storage: 'local' | 'session' = this.defaultStorage,
  ): Storage {
    return storage === 'local' ? localStorage : sessionStorage;
  }
}
